import { View } from 'react-native'

import { PublicationItem } from '@/src/features/publication/ui/components/PublicationItem'
import type { TPublicationItemProps } from '@/src/features/publication/ui/components/PublicationItem'
import { PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import type { useCommunitySubscriptionsQuery } from '../../services/useCommunitySubscriptionsQuery'
import { itemClassName } from '../screens/CommunityScreen/PublicationsPlaceholders'

type TCommunityPublicationItemProps = {
  publication: Omit<TPublicationItemProps['publication'], 'community'>
  community: TPublicationItemProps['publication']['community']
  subscription: ReturnType<typeof useCommunitySubscriptionsQuery>['activeSubscription']
  featuredPublicationId?: number
  trackingSource?: TRACKING_SOURCE
}

const isYetToBeReceived = ({
  publication,
  subscription,
}: Pick<TCommunityPublicationItemProps, 'publication' | 'subscription'>) => {
  if (!subscription) return false // Unsubscribed
  if (!subscription.lastPublicationReceived) return true // Unstarted journey: nothing received yet
  if (subscription.lastPublicationReceived.rank === null) return false // CDI: no rank known
  return publication.rank > subscription.lastPublicationReceived.rank // Started journey
}

export const CommunityPublicationItem = ({
  subscription,
  publication,
  community,
  featuredPublicationId = subscription?.nextPublication?.id,
  trackingSource = TRACKING_SOURCE.COMMUNITY_PAGE,
}: TCommunityPublicationItemProps) => (
  <View key={publication.id} className={itemClassName}>
    <PublicationItem
      isNextToBePrayed={publication.id === featuredPublicationId}
      publication={{
        ...publication,
        community,
        ...(isYetToBeReceived({ publication, subscription }) && { isScheduled: true, published: false }),
      }}
      publicationTrackingSource={PUBLICATION_TRACKING_SOURCE.COMMUNITY_READ_MORE}
      trackingSource={trackingSource}
    />
  </View>
)
